import {
  productsUrl, PER_PAGE, productCard,
} from '../../src/js/product-listing';

// "Load more" for blocks set to show all products (limit -1). Page 1 is
// rendered server-side; the block can appear several times on a page.
const initLoadMore = (block) => {
  const grid = block.querySelector('.products-listing__grid');
  const wrap = block.querySelector('.products-listing__load-more');
  const btn = wrap?.querySelector('.products-listing__load-more-btn');
  const errorEl = wrap?.querySelector('.products-listing__load-more-error');
  if (!grid || !btn) return;

  const { category = '' } = block.dataset;
  // Must match the server-rendered first page, or pages overlap/skip.
  const perPage = Number(block.dataset.perPage) || PER_PAGE;
  let page = 1;

  btn.addEventListener('click', () => {
    // URL API keeps an existing query (e.g. ?rest_route= without pretty
    // permalinks); the base resolves the relative fallback productsUrl.
    const url = new URL(productsUrl, window.location.href);
    url.searchParams.set('order', 'ASC');
    url.searchParams.set('page', page + 1);
    url.searchParams.set('per_page', perPage);
    if (category) url.searchParams.set('current_category', category);

    btn.disabled = true;
    if (errorEl) errorEl.hidden = true;
    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(({ products, has_more: hasMore }) => {
        const html = products.map(productCard).join('');
        grid.insertAdjacentHTML('beforeend', html);
        page += 1;
        wrap.hidden = !hasMore;
      })
      .catch((err) => {
        // page is not advanced, so the next click retries the same page.
        // eslint-disable-next-line no-console
        console.error('[products-listing] load more failed', {
          url: url.href, page: page + 1, category, err,
        });
        if (errorEl) errorEl.hidden = false;
      })
      .finally(() => {
        btn.disabled = false;
      });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.products-listing').forEach(initLoadMore);
});
